<template>
  <v-card class="item" :to="to" height="100%" flat>
    <img
      class="d-block item-img"
      :src="files + img + '?resize=1&w=360'"
      :alt="title"
      width="100%"
    />

    <div class="py-2 px-3 py-md-4 px-md-6">
      <div
        class="
          primary--text
          text--darken-4 text-body-1 text-md-h6
          font-weight-medium
          item-title
        "
      >
        {{ title }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 4 / 3;
    -o-object-fit: cover;
    object-fit: cover;
  }

  &-title {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
